import { useState } from "react";
import type { SiteSettings } from "@/mocks/adminData";

interface ComplaintSectionProps {
  settings: SiteSettings;
}

export default function ComplaintSection({ settings }: ComplaintSectionProps) {
  const [copied, setCopied] = useState(false);

  const handle = settings.complaint_handle || "@hx_zs888";
  const name = settings.complaint_name || "迪猫";
  const tgUrl = settings.complaint_tg_url || "https://t.me/hx_zs888";

  const handleCopy = () => {
    navigator.clipboard.writeText(handle).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <section id="complaint" className="w-full py-5 md:py-10" style={{ background: "#eef2f7" }}>
      <div className="max-w-6xl mx-auto px-4 md:px-8 lg:px-10">
        <div className="flex items-center gap-2 mb-4 md:mb-6">
          <span className="w-1 h-5 rounded-full bg-red-500 flex-shrink-0"></span>
          <h2 className="text-base md:text-lg font-bold text-gray-800">投诉接受</h2>
          <span className="text-xs text-gray-400 ml-1">全程跟进对接,沟通无障碍</span>
        </div>
        <div className="bg-white rounded-xl border border-gray-100 p-5 md:p-6 max-w-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-full bg-gradient-to-br from-red-400 to-orange-400 flex items-center justify-center text-white font-bold">
                {name.charAt(0)}
              </div>
              <span className="text-sm font-semibold text-gray-700">{name}</span>
            </div>
            <div className="flex items-center gap-3">
              <a href={tgUrl} target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-telegram-fill text-sky-500 text-xl"></i>
                </div>
                <span className="text-sm text-gray-600">{handle}</span>
              </a>
              <button
                onClick={handleCopy}
                title="复制"
                className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 transition-colors cursor-pointer"
              >
                {copied ? (
                  <i className="ri-check-line text-green-500"></i>
                ) : (
                  <i className="ri-file-copy-line text-gray-400"></i>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}